import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AlertData } from '../../../core/ui/alert-data';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatFormFieldModule],
  templateUrl: './alert.html',
  styleUrl: './alert.css'
})
export class Alert {
	constructor(@Inject(MAT_DIALOG_DATA) public data: AlertData, public dialogRef: MatDialogRef<Alert>) {}

	get iconType(): string {
		switch(this.data.type) {
			case 'success': return 'check-circle';
			case 'error': return 'error';
			case 'info': return 'info';
			case 'warning': return 'warning';
			default: return 'info';
		}
	}

	onConfirm(): void {
		this.dialogRef.close();
	}
}
